import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { any, func } from "prop-types";
import moment from "moment";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import { postCompleatFoodForm } from "../../redux/actions/index";
import {
  formCreatorConvertToValues,
  getField,
  useForm,
} from "../../common/FormCreator/helpers";
import HorizontalLine from "../../common/HorizontalLine/index";
import buildAddress from "./helpers";
import { allFieldsFilled } from "../../helpers/form";

const MedicalQuestionnaireForm = ({ appData, postForm }) => {
  const initialData = {
    // personal  details
    title: appData.title,
    titleOther: "",
    sex: "",
    firstName: appData.firstName,
    lastName: appData.lastName,
    previousNames: "",
    dateOfBirth: appData.dateOfBirth,
    jobTitle: "",
    department: "",
    site: "",
    manager: "",
    workedBeforeCheck: "",
    homeAddress: buildAddress(appData),
    postcode: appData.address && appData.address.postcode,
    mobileTelephone: appData.mobileTelephone,
    homeTelephone: appData.homeTelephone,
    nameOfGP: "",
    addressOfGP: "",
    postcodeOfGP: "",
    phoneOfGP: "",
    // Previous Employment
    daysAbsentFromWork: "",
    initialWorkHistory: [
      {
        Employer: "",
        "Nature of Work": "",
        "Start Date": "",
        "Finish Date": "",
      },
    ],
    initialErrorMessages: [
      {
        toAfterFromDate: "",
        tooBigGap: "",
      },
    ],
    // COVID 19
    haveIllnessAffectWork: "",
    haveIllnessAffectWorkDependOn: "",
    haveIllnessCausedByWork: "",
    haveIllnessCausedByWorkDependOn: "",
    waitingForTreatment: "",
    waitingForTreatmentDependOn: "",
    needAssistance: "",
    needAssistanceDependOn: "",
    colourBlindness: "",
    covidTest: "",
    beenIsolated: "",
    covidSymptoms: "",
    sexDependOn: "",
    breathingProblems: "",
    breathingProblemsDependOn: "",
    allergies: "",
    allergiesDependOn: "",
    hadCough: "",
    hadTuberculosis: "",
    hadTuberculosisDependOn: "",
    athletesFoot: "",
    weaknessInBody: "",
    injuryInBody: "",
    operationsInBody: "",
    deformityInBody: "",
    historyProblemsInBody: "",
    pastStrainInjury: "",
    hadInfections: "",
    hadDiarrhoea: "",
    hadTyphoid: "",
    hadHepatitis: "",
    hadDermatitis: "",
    hadBoils: "",
    wasAbroad: "",
    wasAbroadDependOn: "",
    biteNails: "",
    visitDentist: "",
    contactWithTyphoid: "",
    signature: `${appData.firstName} ${appData.lastName}`,
    date: moment().format("DD/MM/YYYY"),
  };
  const getVal = getField(initialData);

  const initialState = {
    blurb1: {
      htmlObj: (
        <div>
          <div className={"text-center"}>
            <p>
              <strong>Occupational Health Department</strong>
            </p>
            <p>
              <strong>New Starter Assessment</strong>
            </p>
          </div>
          <p>
            Your answers to this questionnaire will be confidential to HR and
            Occupational Health and will not be given to anyone else without
            your written permission. The purpose of the questionnaire is to see
            whether you have any health problems that could affect your ability
            to undertake the duties of the post you have been offered or place
            you at any risk in the workplace. We may recommend adjustments or
            assistance as a result of this assessment to enable you to do the
            job. Our aim is to promote and maintain the health of all our
            employees.
          </p>
          <p>
            At the start of your employment you may be contacted by a member of
            the Occupational Health Team and may need to be seen by an
            Occupational Health Advisor for a medical.
          </p>
        </div>
      ),
    },
    blurb2: {
      htmlObj: <HorizontalLine text="Personal Details" />,
    },
    title: {
      title: "Title",
      value: getVal("title"),
      type: "radio",
      radioOptions: ["Ms", "Miss", "Mrs", "Mr", "Dr", "Professor", "Other"],
      mandatory: true,
    },
    titleDependOn: {
      title: "If Other, please specify",
      value: getVal("titleOther"),
      dependOn: [{ fieldKey: "title", allowedValues: ["Other"] }],
      mandatory: true,
    },
    firstName: {
      title: "First Name",
      value: getVal("firstName"),
      mandatory: true,
    },
    lastName: {
      title: "Surname / Family Name",
      value: getVal("lastName"),
      mandatory: true,
    },
    previousNames: {
      title: "Previous Names (if applicable)",
      value: getVal("previousNames"),
    },
    sex: {
      title: "Sex",
      value: getVal("sex"),
      type: "radio",
      radioOptions: ["Male", "Female"],
      mandatory: true,
    },
    dateOfBirth: {
      type: "date",
      title: "Date of Birth",
      value: getVal("dateOfBirth"),
      mandatory: true,
    },
    jobTitle: {
      title: "Proposed Job Title",
      value: getVal("jobTitle"),
    },
    department: {
      title: "Department",
      value: getVal("department"),
    },
    manager: {
      title: "Manager (if known)",
      value: getVal("manager"),
    },
    site: {
      title: "Site",
      value: getVal("site"),
    },

    workedBeforeCheck: {
      title: "Have you worked here before?",
      value: getVal("workedBeforeCheck"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    homeAddress: {
      title: "Home Address",
      value: getVal("homeAddress"),
      mandatory: true,
    },
    postcode: {
      title: "Post code",
      value: getVal("postcode"),
      mandatory: true,
    },
    homeTelephone: {
      title: "Telephone",
      value: getVal("homeTelephone"),
      mandatory: true,
    },
    mobileTelephone: {
      title: "Mobile",
      value: getVal("mobileTelephone"),
      mandatory: true,
    },
    nameOfGP: {
      title: "Name of GP",
      value: getVal("nameOfGP"),
      mandatory: true,
    },
    addressOfGP: {
      title: "Address of GP",
      value: getVal("addressOfGP"),
      mandatory: true,
    },
    postcodeOfGP: {
      title: "Postcode of GP",
      value: getVal("postcodeOfGP"),
      mandatory: true,
    },
    phoneOfGP: {
      title: "GP Telephone Number",
      value: getVal("phoneOfGP"),
      mandatory: true,
    },

    blurb3: {
      htmlObj: (
        <div>
          <HorizontalLine text="Previous Employment in the Last 5 Years" />
        </div>
      ),
    },

    workHistory: {
      type: "workHistoryV2",
      workHistoryColumns: [
        {
          title: "Employer",
          type: "text",
          format: "",
        },
        {
          title: "Nature of Work",
          type: "text",
          format: "",
        },
        {
          title: "Start Date",
          type: "date",
          format: "",
        },
        {
          title: "Finish Date",
          type: "date",
          format: "",
        },
      ],
      initialWorkHistory: {
        Employer: "",
        "Nature of Work": "",
        "Start Date": "",
        "Finish Date": "",
      },
    },
    daysAbsentFromWork: {
      type: "number",
      title: "Number of Days Absent from Work in the Last Year",
      value: getVal("daysAbsentFromWork"),
    },
    blurb4: {
      htmlObj: (
        <div>
          <HorizontalLine text="Health Assessment – General" />
        </div>
      ),
    },
    haveIllnessAffectWork: {
      title:
        "Do you have any illness / impairment / disability (physical or psychological) which may affect your work?",
      value: getVal("haveIllnessAffectWork"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    haveIllnessAffectWorkDependOn: {
      title: "If yes, please give details below.",
      value: getVal("haveIllnessAffectWorkDependOn"),
      mandatory: true,
      dependOn: [{ fieldKey: "haveIllnessAffectWork" }],
    },
    haveIllnessCausedByWork: {
      title:
        "Have you ever had any illness / impairment / disability which may have been caused or made worse by your work?",
      value: getVal("haveIllnessCausedByWork"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    haveIllnessCausedByWorkDependOn: {
      title: "If yes, please give details below.",
      value: getVal("haveIllnessCausedByWorkDependOn"),
      mandatory: true,
      dependOn: [{ fieldKey: "haveIllnessCausedByWork" }],
    },
    waitingForTreatment: {
      title:
        "Are you having, or waiting for treatment (including medication) or investigations at present?",
      value: getVal("waitingForTreatment"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    waitingForTreatmentDependOn: {
      title:
        "If yes, please provide further details of the condition, treatment and dates below.",
      value: getVal("waitingForTreatmentDependOn"),
      mandatory: true,
      dependOn: [{ fieldKey: "waitingForTreatment" }],
    },
    needAssistance: {
      title:
        "Do you think you may need any adjustments or assistance to help you to do the job?",
      value: getVal("needAssistance"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    needAssistanceDependOn: {
      title: "If yes, please give details below.",
      value: getVal("needAssistanceDependOn"),
      mandatory: true,
      dependOn: [{ fieldKey: "needAssistance" }],
    },
    colourBlindness: {
      title: "Do you suffer with colour blindness?",
      value: getVal("colourBlindness"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    blurb5: {
      htmlObj: (
        <div>
          <HorizontalLine text="COVID-19" />
        </div>
      ),
    },
    covidTest: {
      title:
        "Have you been for a COVID-19 Test and not received the results yet?",
      value: getVal("covidTest"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    beenIsolated: {
      title:
        "Have any of your household been isolating in the last 14 days or currently isolating?",
      value: getVal("beenIsolated"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    covidSymptoms: {
      title: "Have you got any COVID-19 symptoms? (Cough, Temperature etc.)",
      value: getVal("covidSymptoms"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    sexDependOn: {
      title:
        "Females only (in order that a risk assessment can be carried out), are you pregnant, given birth in the previous 6 months or a nursing mother?",
      value: getVal("sexDependOn"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
      dependOn: [{ fieldKey: "sex", allowedValues: ["Female"] }],
    },
    breathingProblems: {
      title: "Do you suffer from breathing problems (e.g. Asthma)?",
      value: getVal("breathingProblems"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    breathingProblemsDependOn: {
      title: "If yes, please provide details below.",
      value: getVal("breathingProblemsDependOn"),
      mandatory: true,
      dependOn: [{ fieldKey: "breathingProblems" }],
    },
    allergies: {
      title: "Do you have any allergies?",
      value: getVal("allergies"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    allergiesDependOn: {
      title: "If yes, please provide details below.",
      value: getVal("allergiesDependOn"),
      mandatory: true,
      dependOn: [{ fieldKey: "allergies" }],
    },
    hadCough: {
      title: "Have you had a cough that lasts more than 3 weeks?",
      value: getVal("hadCough"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    hadTuberculosis: {
      title:
        "Have you had tuberculosis (TB) or been in recent contact with open TB?",
      value: getVal("hadTuberculosis"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    hadTuberculosisDependOn: {
      title: "If yes, please provide details below.",
      value: getVal("hadTuberculosisDependOn"),
      mandatory: true,
      dependOn: [{ fieldKey: "hadTuberculosis" }],
    },
    athletesFoot: {
      title: "Do you suffer with Athletes Foot?",
      value: getVal("athletesFoot"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    blurb6: {
      htmlObj: (
        <div>
          <p>
            <strong>
              You are further advised that the repetitive nature of the manual
              work involved in the workplace could cause or aggravate any of the
              following conditions. Do you have or have had:
            </strong>
          </p>
        </div>
      ),
    },
    weaknessInBody: {
      title:
        "Any weakness in the back, neck, shoulders, arms, wrists, hands or fingers?",
      value: getVal("weaknessInBody"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    injuryInBody: {
      title:
        "Suffered any injury to back, shoulders, arms, wrists, hands or fingers?",
      value: getVal("injuryInBody"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    operationsInBody: {
      title:
        "Had any operations to back, neck, shoulders, arms, wrists, hands or fingers?",
      value: getVal("operationsInBody"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    deformityInBody: {
      title:
        "Have any deformity of back, neck, shoulders, arms, wrists, hands or fingers?",
      value: getVal("deformityInBody"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    historyProblemsInBody: {
      title:
        "Had any history of back, neck, shoulders, arms, wrists, hands or finger problems of any nature?",
      value: getVal("historyProblemsInBody"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    pastStrainInjury: {
      title:
        "Have suffered in the past from Repetitive Strain Injury, Tenosynovitis, Carpal Tunnel Syndrome or any other pain in wrist(s), hand(s) or finger(s)?",
      value: getVal("historyProblemsInBody"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    blurb7: {
      htmlObj: (
        <div>
          <HorizontalLine text="Health Assessment – Food Handlers" />
          <p>
            <strong>Do you have, or have you previously suffered from:</strong>
          </p>
        </div>
      ),
    },
    hadInfections: {
      title:
        "Recurrent infections of the mouth, nose, throat, eyes, and ears (including discharging ear)?",
      value: getVal("historyProblemsInBody"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    hadDiarrhoea: {
      title:
        "Diarrhoea or vomiting lasting for more than 24 hours in the last 12 months?",
      value: getVal("hadDiarrhoea"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    hadTyphoid: {
      title: "Typhoid, Paratyphoid, Dysentery, or Salmonella infection?",
      value: getVal("hadTyphoid"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    hadHepatitis: {
      title: "Liver complaints or hepatitis?",
      value: getVal("hadHepatitis"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    hadDermatitis: {
      title: "Skin condition, e.g. dermatitis, eczema, scabies, warts?",
      value: getVal("hadDermatitis"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    hadBoils: {
      title: "Recurrent boils, septic fingers?",
      value: getVal("hadBoils"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    wasAbroad: {
      title: "Have you been abroad in the last 3 months?",
      value: getVal("wasAbroad"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    wasAbroadDependOn: {
      title: "If yes, please give details or where and when below.",
      value: getVal("wasAbroadDependOn"),
      mandatory: true,
      dependOn: [{ fieldKey: "wasAbroad" }],
    },
    biteNails: {
      title: "Do you bite your nails?",
      value: getVal("biteNails"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    visitDentist: {
      title: "Is it more than 12 months since you last visited your dentist?",
      value: getVal("biteNails"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    contactWithTyphoid: {
      title:
        "In the last 21 days have you been in contact with anyone, at home or abroad, who may have been suffering from Typhoid or Paratyphoid?",
      value: getVal("biteNails"),
      type: "checkbox",
      checkboxText1: "Yes",
      checkboxText2: "No",
      mandatory: true,
    },
    blurb8: {
      htmlObj: (
        <div>
          <p>
            <strong>
              <u>Declaration</u>
            </strong>
          </p>
          <p>
            I declare that the answers to the above questions are true and
            complete to the best of my knowledge and belief.
          </p>
          <p>
            I am aware that non-disclosure or false information may result in
            disciplinary action.
          </p>
        </div>
      ),
    },

    signature: {
      title: "Signed",
      value: getVal("signature"),
      mandatory: true,
      disabled: true,
    },
    date: {
      title: "Dated",
      value: getVal("date"),
      mandatory: true,
      disabled: true,
    },
  };
  const [workHistoryData, setWorkHistoryData] = useState(
    initialData.initialWorkHistory
  );
  const [validationErrorMessage, setValidationErrorMessage] = useState(
    initialData.initialErrorMessages
  );
  const [fields, setField] = useForm(initialState);
  const [shouldDisable, setShouldDisable] = useState(true);

  const submitted =
    appData.compleatFoodOnboarding && appData.compleatFoodOnboarding.YCF4;

  const redirectBack = () => {
    history.push("/profile/edit/compleat-food-onboarding");
  };

  const handleSubmit = () => {
    const fieldValuesPayloadData = formCreatorConvertToValues(fields);
    const fieldValuesPayload = Object.fromEntries(
      Object.entries(fieldValuesPayloadData).map(([key, value]) => {
        if (typeof value === "string") {
          return [key, value.toUpperCase()];
        }
        return [key, value];
      })
    );
    const workHistoryPayload = workHistoryData.map((el) => {
      return Object.fromEntries(
        Object.entries(el).map(([key, value]) => [key, value.toUpperCase()])
      );
    });

    postForm("YCF4", {
      ...fieldValuesPayload,
      ...workHistoryPayload,
    });
    redirectBack();
  };

  const removeLastWork = () => {
    const newArr = [...workHistoryData];
    newArr.splice(newArr.length - 1);
    setWorkHistoryData(newArr);
  };

  const setValueWork = (value, key, i) => {
    const mappedHistoryData = workHistoryData.map((el, index) => {
      if (i === index) {
        return { ...el, [key]: value };
      }
      return el;
    });

    setWorkHistoryData(mappedHistoryData);
  };

  useEffect(() => {
    let areErrorMessagesEmpty = true;
    const validationMessages = [];

    if (workHistoryData[0]["Finish Date"] && workHistoryData[0]["Start Date"]) {
      let oldestDate = moment(workHistoryData[0]["Finish Date"]).format(
        "YYYY-MM-DD"
      );
      let earliestDate = moment(workHistoryData[0]["Start Date"]).format(
        "YYYY-MM-DD"
      );

      workHistoryData.forEach((el, i) => {
        const from = el["Start Date"]
          ? moment(el["Start Date"]).format("YYYY-MM-DD")
          : null;
        const to = el["Finish Date"]
          ? moment(el["Finish Date"]).format("YYYY-MM-DD")
          : null;

        // Validation if 'from' date is before 'to' date validation
        if (from && to && moment(to).isBefore(from)) {
          const prev = validationMessages[i] ? validationMessages[i] : {};
          validationMessages[i] = {
            ...prev,
            toAfterFromDate: "End date can not be after Start date",
          };
        }

        if (from && moment(from).isBefore(oldestDate)) {
          oldestDate = from;
        }

        if (to && moment(to).isAfter(earliestDate)) {
          earliestDate = to;
        }
      });
    }

    validationMessages.forEach((el) => {
      Object.keys(el).forEach((key) => {
        if (el[key] && Object.keys(el[key]).length > 0) {
          areErrorMessagesEmpty = false;
        }
      });
    });

    setValidationErrorMessage(validationMessages);

    if (areErrorMessagesEmpty) {
      setShouldDisable(false);
    } else {
      setShouldDisable(true);
    }
  }, [shouldDisable, workHistoryData]);

  return (
    <>
      {submitted ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={"New Starter Medical Questionnaire"}
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"compleatFood"}
          useSubmitText={true}
          handleSubmit={handleSubmit}
          workHistoryData={workHistoryData}
          setWorkHistoryData={setWorkHistoryData}
          removeLast={removeLastWork}
          setValue={setValueWork}
          shouldDisable={shouldDisable}
          workValidationErrorMessage={validationErrorMessage}
          workHistoryDataTitle={" "}
        />
      )}
    </>
  );
};

MedicalQuestionnaireForm.propTypes = {
  appData: any,
  postForm: func,
};

const mapDispatchToProps = {
  postForm: postCompleatFoodForm,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(MedicalQuestionnaireForm);
